// extracted by mini-css-extract-plugin
export default {"social__icon":"AboutHero_social__icon__SRe2Z","button__resume":"AboutHero_button__resume__tErTs","button__contact":"AboutHero_button__contact__fjDQr"};